import styled from "styled-components";

const S = {
    Wrapper: styled.div`
       display: flex;
       flex-direction: column;
       width:100%;
       background: '#f2f5f4';
       max-height:1000px;
       padding-top:20px;
    `,
    Head: styled.div`
    display:flex;
    flex-direction: row;
    flex-wrap:wrap;
    justify-content:center;
    gap:20px;
    align-items: center;
    z-index: 99999999999999999;
    .filterItems{
         /* margin: '20px auto'; */
    }
    `,
    Content: styled.div`
        align-items: stretch;
        width: 100%;
        height: auto;
        grid-gap : 5px;
        padding: 10px; 
        box-sizing: border-box;
        background: #f2f5f4;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto auto;
        grid-template-areas: "dater"
        "tableheader"
        "data";
        justify-items:stretch;
        p{
            &:first-child{
                grid-area: dater;
            }
        }
        .data{
            grid-area:data;
            /* display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center; */
            /* justify-items: center; */
            display: grid;
            grid-template-columns: 1fr;
            grid-auto-rows: auto;
            grid-gap: 20px;
        }
        .detayheader{
            grid-area: tableheader;
                z-index: 100;
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                margin:0;
                padding: 0;
                align-items: center;
                background: #28302c;
                border-radius: 8px;
                li{
                    flex-basis: 100%;
                    font-size:12px;
                    
                    padding: 10px;
                    color:white;
                    &:last-child{
                        padding-right: 24px;
                    }
                }
                  /* li:first-child{
                    padding: 10px;
                    background: #28302c;
                    box-sizing: border-box;
                    border-radius: 8px;
                    margin:5px 0px;
                    color:white;
                    font-size: 12px;
                    div{
                      width: 16%;
                      float: left;
                    }
                    div:last-child{
                      cursor: pointer;
                    }
                  } */

                }
        .detaylist{
            grid-area: data;
            z-index: 50;
            margin:0px;
            padding:0px;
            width:100%;
            height: 500px;
            overflow-y: scroll;
            overflow-x: none;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            li{
            /* padding: 10px; */
            background: white;
            box-sizing: border-box;
            border-radius: 8px;
            margin:5px 0px;
            color:#28302c;
            font-size: 12px;
            display: flex;
            flex-direction:row;
            flex-wrap: nowrap;
            div{
                flex-basis: 100%;
                padding: 10px;
                .Olumlu{
                color: #1cd67c;
                font-weight: bold;
                }
                .Olumsuz{
                color: $red;
                font-weight: bold;
                }
            }
            &:hover{
                background: #19B5FE;
                color:white;
            }
            }
            &::-webkit-scrollbar {
                width: 13px;
                height: 18px;
            }
            &::-webkit-scrollbar-thumb {
                height: 6px;
                border: 4px solid rgba(0, 0, 0, 0);
                background-clip: padding-box;
                -webkit-border-radius: 7px;
                background-color: #d6dcda;
            }
            &::-webkit-scrollbar-button {
                width: 0;
                height: 0;
            }
        }
    `,
    PieWrap: styled.div`
                  width: 280px;
                  height: 100%;
                  background: white;
                  border-radius: 8px;
                  padding: 10px;
                  box-sizing: border-box;
                  margin:10px;
                
    `
}
export default S